export const CURRENCY_FMT = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

export function formatCurrency(val) {
  return "$" + (parseFloat(val) || 0).toLocaleString("en-US", CURRENCY_FMT);
}

export function formatCompact(val) {
  const v = parseFloat(val) || 0;
  if (v >= 1000) return "$" + (v / 1000).toFixed(1) + "k";
  return formatCurrency(v);
}

export function formatChange(pct) {
  if (pct == null) return "";
  const arrow = pct >= 0 ? "\u25B2" : "\u25BC";
  return arrow + " " + Math.abs(pct).toFixed(1) + "%";
}

export function changeClass(pct) {
  if (pct == null) return "";
  return pct >= 0 ? "change-up" : "change-down";
}

export function toDateStr(d) {
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0")
  );
}

export function toMonthStr(d) {
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0")
  );
}

export function defaultDateRange(days = 29) {
  const now = new Date();
  const start = new Date(now);
  start.setDate(start.getDate() - days);
  return { start: toDateStr(start), end: toDateStr(now) };
}

export function buildDonutSegments(items, pctKey, colorFn) {
  const r = 80;
  const circ = 2 * Math.PI * r;
  const gap = 3;
  let offset = 0;
  return items.map((item, i) => {
    const arc = ((item[pctKey] || 0) / 100) * circ;
    const visible = Math.max(arc - gap, 0);
    const seg = {
      dashArray: visible + " " + (circ - visible),
      dashOffset: -offset,
      color: colorFn(item, i),
    };
    offset += arc;
    return seg;
  });
}

export function donutHitTest(evt, svg, items, pctKey) {
  const rect = svg.getBoundingClientRect();
  const svgX = ((evt.clientX - rect.left) / rect.width) * 200;
  const svgY = ((evt.clientY - rect.top) / rect.height) * 200;
  const dx = svgX - 100;
  const dy = svgY - 100;
  const dist = Math.sqrt(dx * dx + dy * dy);

  if (dist < 58 || dist > 102) return null;

  let angle = (Math.atan2(dx, -dy) * 180) / Math.PI;
  if (angle < 0) angle += 360;

  let cum = 0;
  let found = null;
  for (const item of items) {
    const seg = ((item[pctKey] || 0) / 100) * 360;
    if (angle < cum + seg) { found = item; break; }
    cum += seg;
  }
  if (!found) return null;

  const wrap = svg.closest(".donut-wrap");
  const wrapRect = wrap.getBoundingClientRect();
  return {
    item: found,
    x: evt.clientX - wrapRect.left + 14,
    y: evt.clientY - wrapRect.top - 10,
  };
}

export function smoothCurve(pts) {
  let c = "";
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[Math.max(0, i - 1)];
    const p1 = pts[i];
    const p2 = pts[i + 1];
    const p3 = pts[Math.min(pts.length - 1, i + 2)];
    c +=
      " C " +
      (p1[0] + (p2[0] - p0[0]) / 6) + " " +
      (p1[1] + (p2[1] - p0[1]) / 6) + "," +
      (p2[0] - (p3[0] - p1[0]) / 6) + " " +
      (p2[1] - (p3[1] - p1[1]) / 6) + "," +
      p2[0] + " " + p2[1];
  }
  return c;
}

export function fmtHour12(h) {
  const hr = ((h % 24) + 24) % 24;
  if (hr === 0) return "12am";
  if (hr < 12) return hr + "am";
  if (hr === 12) return "12pm";
  return (hr - 12) + "pm";
}

export function buildColorMap(items, nameKey, colorConstMap, fallback = "#6b7280") {
  const map = {};
  for (const item of items) {
    const name = item[nameKey];
    map[name] = (colorConstMap[name] || {}).color || fallback;
  }
  return map;
}

export function niceNum(range) {
  if (range <= 0) return 1;
  const exp = Math.floor(Math.log10(range));
  const frac = range / Math.pow(10, exp);
  const nice = frac <= 1.5 ? 1 : frac <= 3 ? 2 : frac <= 7 ? 5 : 10;
  return nice * Math.pow(10, exp);
}

export function niceScale(maxVal, divisions = 4) {
  if (maxVal <= 0) return { ticks: [1], max: 1 };
  const step = niceNum(maxVal / divisions);
  const max = Math.ceil(maxVal / step) * step;
  const ticks = [];
  for (let v = step; v <= max + 0.001; v += step) ticks.push(v);
  return { ticks, max };
}

export function xLabelInterval(n) {
  return n <= 10 ? 1 : n <= 20 ? 3 : n <= 40 ? 5 : n <= 80 ? 10 : 14;
}

export function clampTipX(x, wrapWidth) {
  return x > wrapWidth - 190 ? x - 210 : x;
}
